/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyCategoryQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyCategoryQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyCategoryQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyCategoryQueryOperator>): PolicyCategoryQueryOperator {
        let obj = Object.assign(new PolicyCategoryQueryOperator(), model);
        PolicyCategoryQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyCategoryQueryOperator>): PolicyCategoryQueryOperator {
        if (!model) return null;
        return PolicyCategoryQueryOperator.newInstance(<PolicyCategoryQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyCategoryQueryOperator) {
        if (!obj) return;

        models.PolicyCategoryQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyCategoryQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyCategoryQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy categories to include
     */
    categories: Array<string>;

}
